var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6666C17.4728 18.6666 18.6667 17.4727 18.6667 15.9999C18.6667 14.5272 17.4728 13.3333 16 13.3333C14.5273 13.3333 13.3333 14.5272 13.3333 15.9999C13.3333 17.4727 14.5273 18.6666 16 18.6666Z",
    fill: "#757B83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 18.6666C26.8061 18.6666 28 17.4727 28 15.9999C28 14.5272 26.8061 13.3333 25.3333 13.3333C23.8606 13.3333 22.6667 14.5272 22.6667 15.9999C22.6667 17.4727 23.8606 18.6666 25.3333 18.6666Z",
    fill: "#757B83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 18.6666C8.13943 18.6666 9.33333 17.4727 9.33333 15.9999C9.33333 14.5272 8.13943 13.3333 6.66667 13.3333C5.19391 13.3333 4 14.5272 4 15.9999C4 17.4727 5.19391 18.6666 6.66667 18.6666Z",
    fill: "#757B83"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.c34933bd34181c61ce11bd90021834ff.svg";
export { ForwardRef as ReactComponent };